export default __webpack_public_path__ + "404-screen.html";